import { Component, inject, Input } from '@angular/core'
import { SystemConfigService } from '@account/Services/SystemConfigService'
import { DateTimeComponent as DateTimeComponentInner } from '@ui/Components/DateTime/DateTime.Component'

@Component({
	selector: 'date-time',
	template:
		'<date-time-component-inner [date]="date" [includeTime]="includeTime" [timezone]="timezone"></date-time-component-inner>',
	imports: [DateTimeComponentInner],
})
export class DateTimeComponent {
	@Input() public date: string

	@Input() public includeTime = false

	public timezone: string

	constructor() {
		const systemConfigService = inject(SystemConfigService)
		this.timezone = systemConfigService.config.timezone
	}
}
